/**
 * @param {obj} 值
 * @description 对象恢复初始状态
 */
 export function objectRestore(obj) {
  const object = { ...obj }
  for (var key in object) {
    const val = object[key]
    if (val instanceof Array) object[key] = []
    else object[key] = void 0
  }
  return object
}

import axios from 'axios';
import { API } from '@/axios/config';
import store from '@/store/index';

/**
 * 
 * @param {*} params 
 * @param {*} fileName 
 * @param {*} type 
 * @returns 
 */
export function onDownload(params, fileName, type){
  const urls =  API.UploadsService + 'backstage/annex/downLoad'
  let token = store.state.user.token;
  return new Promise((resolve, reject) => {
    
      axios({
          method: type || 'post',
          data:params,
          url:urls,
          headers:{
            'Content-Type': 'multipart/form-data' ,
            'Authorization': `Bearer ${token}`
          },
          responseType: 'blob' // 文件流数据一定要写
      }).then(res => {
          // 处理文档流
          const blob = new Blob([res.data], {
              type: 'application/msword'
          })
          if (!!window.ActiveXObject || 'ActiveXObject' in window || window.navigator.userAgent
              .indexOf('Edge/') > 0) { // 判断是不是ie的浏览器
              window.navigator.msSaveOrOpenBlob(blob, fileName)
          } else {
              const elink = document.createElement('a')
              elink.download = fileName || '下载文件'
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
          }
      }).catch(e => {
          console.log('下载失败', e)
      })
  })
}
export function getBeforeDate(date,type) {
      let data = date;
      let d = new Date();
      let year = !type?d.getFullYear():data.getFullYear();
      let mon = !type?d.getMonth() + 1:data.getMonth() + 1;
      let day = !type?d.getDate():data.getDate();
      if(!type)
      {
      if (day <= data) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - data);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    }else{
      if(type === 'week'){
        if(day < 10) {
          day = '0' + day;
        }
        
        if(mon < 10) {
          mon = '0' + mon;
        }		
        return year + "-" + mon + "-" + day;
      }else{
        return year + "-" + mon + "-" + day;
      }
    }
 }

 export function downLoadTemplate(url, params, fileName, type){
   const  token = store.state.user.token;
  return new Promise((resolve, reject) => {
    axios({
        method: type || 'GET',
        data:params,
        url: API.baseDataURL + url,
        responseType: 'blob', // 文件流数据一定要写
        headers:{
          'Authorization': `Bearer ${token}`
        },
    }).then(res => {
        // 处理文档流
        const blob = new Blob([res.data], {
            type: 'application/msword'
        })
        if (!!window.ActiveXObject || 'ActiveXObject' in window || window.navigator.userAgent
            .indexOf('Edge/') > 0) { // 判断是不是ie的浏览器
            window.navigator.msSaveOrOpenBlob(blob, fileName)
        } else {
            const elink = document.createElement('a')
            elink.download = fileName || '下载文件'
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
        }
    }).catch(e => {
        console.log('下载失败', e)
    })
})
 }


